import { render, staticRenderFns } from "./reply-comment.vue?vue&type=template&id=58bbeaf9&"
import script from "./reply-comment.vue?vue&type=script&lang=js&"
export * from "./reply-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports